import React, { Component } from 'react';
import NoticeBanner from './NoticeBanner';
import NoticePost from './NoticePost';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';

class NoticePage extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		return (
			<main>
				<NoticeBanner />
				<div className="main-body mt-50 mb-50">
					<div className="container">
						<div className="row">
							<div className="offset-lg-2 col-lg-10 col-md-12 post-list">
								<NoticePost />
								<nav className="blog-pagination justify-content-center d-flex mt-30">
									<ul className="pagination">
										<li className="page-item">
											<a href="/blog-details" className="page-link" aria-label="Previous">
												<span aria-hidden="true">
													<FaArrowLeft />
												</span>
											</a>
										</li>
										<li className="page-item">
											<a href="/" className="page-link">01</a>
										</li>
										<li className="page-item active">
											<a href="/" className="page-link">02</a>
										</li>
										<li className="page-item">
											<a href="/" className="page-link">03</a>
										</li>
										<li className="page-item">
											<a href="/" className="page-link">04</a>
										</li>
										<li className="page-item">
											<a href="/" className="page-link">09</a>
										</li>
										<li className="page-item">
											<a href="/blog-details" className="page-link" aria-label="Next">
												<span aria-hidden="true">
													<FaArrowRight />
												</span>
											</a>
										</li>
									</ul>
								</nav>
							</div>
						</div>
					</div>
				</div>
			</main>
		);
	}
}

export default NoticePage;
